// src/theme.js
import { createTheme } from '@mui/material/styles';

const modernTheme = createTheme({
  direction: 'rtl',
  
  palette: {
    mode: 'light',
    primary: {
      main: '#4F46E5', 
      light: '#818CF8',
      dark: '#3730A3',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#10B981',
      light: '#34D399',
      contrastText: '#ffffff',
    },
    background: {
      default: '#F1F5F9', 
      paper: '#FFFFFF',
    },
    text: {
      primary: '#0F172A', 
      secondary: '#64748B',
    }
  },

  shape: {
    borderRadius: 16, 
  },

  typography: {
    fontFamily: '"Alexandria", sans-serif !important',
    button: {
      fontFamily: '"Alexandria", sans-serif !important',
      fontWeight: 700,
      textTransform: 'none',
    },
    h4: { fontFamily: '"Alexandria", sans-serif !important', fontWeight: 800, letterSpacing: '-0.5px' },
    h5: { fontFamily: '"Alexandria", sans-serif !important', fontWeight: 800 },
    h6: { fontFamily: '"Alexandria", sans-serif !important', fontWeight: 700 },
    body1: { fontFamily: '"Alexandria", sans-serif !important', fontWeight: 500 },
    body2: { fontFamily: '"Alexandria", sans-serif !important', fontWeight: 500 },
    subtitle1: { fontFamily: '"Alexandria", sans-serif !important', fontWeight: 600 },
    subtitle2: { fontFamily: '"Alexandria", sans-serif !important', fontWeight: 600 },
  },

  components: {
    // إجبار الخط على جسم الصفحة بالكامل وكل عناصر الإدخال والنصوص الافتراضية
    MuiCssBaseline: {
      styleOverrides: `
        @import url('https://fonts.googleapis.com/css2?family=Alexandria:wght@300;400;500;600;700;800;900&display=swap');
        
        body, html, * {
          font-family: "Alexandria", sans-serif !important;
        }
        input, button, select, textarea, label, span {
          font-family: "Alexandria", sans-serif !important;
        }
      `,
    },

    // تعديل الخطوط داخل الـ Form Control Label (مثل نص تذكرني)
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontFamily: '"Alexandria", sans-serif !important',
          fontWeight: 600,
        }
      }
    },

    // تعديل الأزرار لتأخذ الخط وتأثير الارتفاع العصري
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: '"Alexandria", sans-serif !important',
          borderRadius: '12px',
          padding: '10px 24px',
          boxShadow: 'none',
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 20px -6px rgba(79, 70, 229, 0.4)',
          },
        },
      },
    },

    // حل مشكلة النصوص الصغيرة فوق الحقول (InputLabel) بشكل جذري
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: '"Alexandria", sans-serif !important',
          fontWeight: 500,
          '&.Mui-focused': {
            fontFamily: '"Alexandria", sans-serif !important',
          }
        }
      }
    },

    // حل مشكلة الحقول والمدخلات الداخلية من كل الزوايا
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
        size: 'small',
      },
      styleOverrides: {
        root: {
          fontFamily: '"Alexandria", sans-serif !important',
          '& .MuiInputLabel-root': {
            fontFamily: '"Alexandria", sans-serif !important',
          },
          '& .MuiOutlinedInput-input': {
            fontFamily: '"Alexandria", sans-serif !important',
            fontWeight: 500,
          },
          '& .MuiInputBase-input': {
            fontFamily: '"Alexandria", sans-serif !important',
          }
        }
      }
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          backgroundColor: 'rgba(248, 250, 252, 0.8)',
          fontFamily: '"Alexandria", sans-serif !important',
          transition: 'all 0.2s ease',
          '& fieldset': {
            borderColor: 'transparent',
          },
          '&:hover fieldset': {
            borderColor: '#CBD5E1',
          },
          '&.Mui-focused': {
            backgroundColor: '#FFFFFF',
            boxShadow: '0 0 0 4px rgba(79, 70, 229, 0.1)',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#4F46E5',
            borderWidth: '2px',
          },
          '& .MuiOutlinedInput-input': {
            fontFamily: '"Alexandria", sans-serif !important',
          }
        },
      },
    },

    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '24px',
          boxShadow: '0 10px 40px -10px rgba(15,23,42,0.08)',
          border: '1px solid rgba(255,255,255,0.7)',
        },
      },
    },
  },
});

export default modernTheme;